import { useRef, useState } from "react";
import { Box, Modal, Slider, Button } from "@mui/material";
import AvatarEditor from "react-avatar-editor"
import { boxStyle, modalStyle } from "./CropImage";



// Modal
const CommonCropImage = ({ src, modalOpen, setModalOpen, handleCropSave }) => {
  const [slideValue, setSlideValue] = useState(10);
  const cropRef = useRef(null);

  //handle save
  const handleSave = async () => {
    if (cropRef) {
      const dataUrl = cropRef.current.getImage().toDataURL();
      const result = await fetch(dataUrl);
      const blob = await result.blob();
      setModalOpen(false);
      handleCropSave(blob)
    }
  };

  return (
    <Modal sx={modalStyle} open={modalOpen} className="avatar">
      <Box sx={boxStyle}>
        <AvatarEditor
          ref={cropRef}
          image={src}
          className="wh100"
          border={50}
          borderRadius={150}
          color={[0, 0, 0, 0.72]}
          scale={slideValue / 10}
          rotate={0}
        />

        {/* MUI Slider */}
        <Slider
          min={10}
          max={50}
          className="sliderAlign"
          size="medium"
          defaultValue={slideValue}
          value={slideValue}
          onChange={(e) => setSlideValue(e.target.value)}
        />
        <Box className='boxAlign'
        >
          <Button
            size="small"
            className="btnCancel"
            variant="outlined"
            onClick={(e) => setModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            className="btnColor"
            size="small"
            variant="contained"
            onClick={handleSave}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
export default CommonCropImage;

